import { render, staticRenderFns } from "./AwayStatusIndicator.vue?vue&type=template&id=b54850fc&"
import script from "./AwayStatusIndicator.vue?vue&type=script&lang=js&"
export * from "./AwayStatusIndicator.vue?vue&type=script&lang=js&"
import style0 from "./AwayStatusIndicator.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports